import { FC, useCallback } from 'react';
import modalClasses from '../../asset/css/common-modal.module.css';
import { CommonModal } from '../CommonModal';
import {MessageContentViewType} from "../../types/view/message-content-view-type";

export const MessageModal: FC<{
  active: boolean;
  scrollOffset: number;
  parentViewportHeight: number;
  marginToTop: number;
  closeFunc: () => void;
  messageContent?: MessageContentViewType;
}> = ({ active, scrollOffset, parentViewportHeight, marginToTop, closeFunc, messageContent }) => {
  const closeBtnClickHandler = useCallback(() => {
    closeFunc();
  }, [closeFunc]);

  const content = (
    <>
      <h2>{messageContent?.title ?? ''}</h2>
      <p>{messageContent?.body ?? ''}</p>
      <button type="button" className={modalClasses.mypage_popup_ok} onClick={closeBtnClickHandler}>
        OK
      </button>
    </>
  );

  return <CommonModal 
    active={active}
    scrollOffset={scrollOffset}
    parentViewportHeight={parentViewportHeight}
    marginToTop={marginToTop}
    closeFunc={closeFunc}
    content={content} />;
};
